module.exports = __webpack_public_path__ + "img/maintenance-11.cb178084.jpg";